import React, { useEffect } from 'react'
import { SiteModule } from 'modules/ravensdown/site'

import { Container, Grid } from '@material-ui/core'

import { styled, s } from 'lib/styled'
import { SiteList } from './SiteList'
import { Map } from './Map'
import { ForecastSlider } from './ForecastSlider'

import { TitleLabel } from 'components/common/styles'

import 'react-map-gl-geocoder/dist/mapbox-gl-geocoder.css'

const Root = styled.div(s('flex-1 flex flex-column items-center pt-8 mb-16'), {
  overflow: 'hidden',
})
const Title = styled(TitleLabel)(s('mt-0 mb-4 text-2xl'))

function Dashboard() {
  useEffect(() => {
    SiteModule.fetchSites()
  }, [])

  return (
    <Root>
      <Container maxWidth="lg" style={s('m-0 h-full')}>
        <Grid
          container
          direction="row"
          spacing={4}
          style={s('h-full', {
            overflow: 'hidden',
          })}
        >
          <Grid
            item
            xs={4}
            style={s('h-full flex flex-column', {
              overflow: 'hidden',
            })}
          >
            <Title>Sites</Title>

            <SiteList />
          </Grid>

          <Grid item xs={8} style={s('h-full flex flex-column')}>
            <Map />
            <ForecastSlider />
          </Grid>
        </Grid>
      </Container>
    </Root>
  )
}

export { Dashboard }
